module.exports = __webpack_public_path__ + "img/toma.6dca2f14.png";